import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ViewTemperature from './components/viewTemperature';
import ViewBasic from './components/viewBasic';

export default class Slider extends Component {
  constructor(props) {
    super(props);
    this.setValueByInput = this.setValueByInput.bind(this);
    this.rangeMouseDown = this.rangeMouseDown.bind(this);
    this.rangeMouseMove = this.rangeMouseMove.bind(this);
    this.calcularPosition = this.calcularPosition.bind(this);
    this.calcularValue = this.calcularValue.bind(this);
    this.state = {
      offset: 10,
      precision: 0,
    };
  }

  componentDidMount() {
    this.determinePrecision();
  }

  componentWillReceiveProps() {
    this.determinePrecision();
  }

  componentWillUnmount() {
    this.inner = undefined;
    this.innerLeft = undefined;
    this.innerRight = undefined;
  }

  /**
   * Set value by input
   * this function is called if the user enters something in the input component
   * @param object event
   * @param number trackFillLeft
   * @param number innerLeft
   * @param number offsetWidth
   * @param number positionIni
   * @param number valueIni
   * @return object {position, value}
   */
  setValueByInput(
    valueNew,
    trackFillLeft,
    innerLeft,
    offsetWidth,
    positionIni,
    valueIni
  ) {
    let value = valueNew;
    const { settings } = this.props;
    let position = positionIni;
    if (value < settings.min) {
      value = settings.min;
      position = this.calcularPosition(
        trackFillLeft,
        innerLeft,
        offsetWidth,
        value
      );
    }
    if (value > settings.max) {
      value = settings.max;
      position = this.calcularPosition(
        trackFillLeft,
        innerLeft,
        offsetWidth,
        value
      );
    }

    /* validation float */
    if (!String(value).match(/^-?[0-9.]*$/)) {
      value = valueIni;
    }

    if (value !== '-') {
      position = this.calcularPosition(
        trackFillLeft,
        innerLeft,
        offsetWidth,
        value
      );
      const valueSplit = value.toString().split('.');
      if (valueSplit.length === 2) {
        if (valueSplit[1].length > 2) {
          value = `${valueSplit[0]}.${valueSplit[1].substr(0, 2)}`;
        }
      }
    }
    if (settings.onChange) {
      settings.onChange(value);
    }
    return {
      position,
      value,
    };
  }

  /**
   * Calcular value
   * This function calculates a value in based the position
   * @param float startPos
   * @param float endPos
   * @param float currentPos
   * @return value
   */
  calcularValue(startPos, endPos, currentPos) {
    const { settings } = this.props;
    const { precision } = this.state;

    const ratio = (currentPos - startPos) / (endPos - startPos);
    const range = settings.max - settings.min;
    let difference =
      Math.round((ratio * range) / settings.step) * settings.step;
    /* Use precision to avoid ugly Javascript floating point rounding issues
    (like 35 * .01 = 0.35000000000000003) */
    difference = Math.round(difference * precision) / precision;
    /* if the calculated value has more als 4 decimal, it will be shown only 4 decimal */
    let value = difference + settings.min;
    /* The value must no be less that the minimun value or greater than the
    maximun value */
    if (value < settings.min) {
      value = settings.min;
    }
    if (value > settings.max) {
      value = settings.max;
    }
    const valueSplit = value.toString().split('.');
    if (valueSplit.length === 2) {
      if (valueSplit[1].length > 2) {
        value = `${valueSplit[0]}.${valueSplit[1].substr(0, 2)}`;
      }
    }
    return value;
  }

  /**
   * Calcular position
   * @param number trackFillLeft
   * @param number innerLeft
   * @param number offsetWidth
   * @param number value
   * @return number position
   */
  calcularPosition(trackFillLeft, innerLeft, offsetWidth, value) {
    const { settings } = this.props;
    const { offset } = this.state;
    const ratio = (value - settings.min) / (settings.max - settings.min);
    return (
      Math.round(ratio * offsetWidth) + trackFillLeft - innerLeft - offset + 5
    );
  }

  /**
   * Range mouse down
   * @param bool isTouch
   * @param object e
   * @param object innerBoundingClientRect
   * @param number offsetWidth
   * @param number positionIni
   * @param number valueIni
   * @return object {position, value}
   */
  rangeMouseDown(
    isTouch,
    e,
    innerBoundingClientRect,
    offsetWidth,
    positionIni,
    valueIni
  ) {
    let position = positionIni;
    let value = valueIni;
    const { offset } = this.state;
    const { settings, disabled } = this.props;
    e.stopPropagation();
    if (!disabled) {
      e.preventDefault();
      this.innerLeft = innerBoundingClientRect.left;
      this.innerRight = this.innerLeft + offsetWidth;
      let pageX;
      if (e.pageX) {
        ({ pageX } = e);
      } else {
        console.error('PageX undefined');
      }
      value = this.calcularValue(this.innerLeft, this.innerRight, pageX);
      if (pageX >= this.innerLeft && pageX <= this.innerRight) {
        if (value < settings.min) {
          position = pageX - offset + 5;
          value = settings.min;
        } else if (value > settings.max) {
          position = pageX + this.innerRight;
          value = settings.max;
        } else {
          position = pageX - this.innerLeft - offset + 5;
        }
      }
    }
    if (settings.onChange) {
      settings.onChange(value);
    }
    return {
      position,
      value,
    };
  }

  /**
   * Range mouse move
   * @param bool isTouch
   * @param object e
   * @param number innerLeft
   * @param number innerRight
   * @param number positionIni
   * @param number valueIni
   * @param bool mouseDown
   * @return object {position, value}
   */
  rangeMouseMove(
    isTouch,
    e,
    innerLeft,
    innerRight,
    positionIni,
    valueIni,
    mouseDown
  ) {
    let position = positionIni;
    let value = valueIni;
    const { offset } = this.state;
    const { settings } = this.props;
    e.stopPropagation();
    e.preventDefault();
    if (mouseDown) {
      let pageX;
      if (isTouch) {
        /* if the trigger event is a touch event, the x position is located in
        the array e.touches[0] */
        pageX = e.touches[0].clientX;
      } else if (e.pageX) {
        ({ pageX } = e);
      } else {
        console.error('PageX undefined');
      }
      value = this.calcularValue(innerLeft, innerRight, pageX);
      if (pageX >= innerLeft && pageX <= innerRight) {
        if (value >= settings.min && value <= settings.max) {
          position = pageX - innerLeft - offset + 5;
        }
      }
    }
    if (settings.onChange) {
      settings.onChange(value);
    }
    return {
      position,
      value,
    };
  }

  /**
   * Determine precision
   */
  determinePrecision() {
    const { settings } = this.props;
    const split = String(settings.step).split('.');
    let decimalPlaces;
    if (split.length === 2) {
      decimalPlaces = split[1].length;
    } else {
      decimalPlaces = 0;
    }
    this.setState({
      precision: 10 ** decimalPlaces,
    });
  }

  render() {
    const { offset, precision } = this.state;
    const {
      basic,
      disabled,
      backgroundColor,
      inverted,
      color,
      unit,
      settings,
      mode,
    } = this.props;
    if (basic) {
      return (
        <ViewBasic
          color={color}
          backgroundColor={backgroundColor}
          inverted={inverted}
          disabled={disabled}
          unit={unit}
          start={settings.start}
          min={settings.min}
          max={settings.max}
          step={settings.step}
          precision={precision}
          offset={offset}
          setValueByInput={this.setValueByInput}
          rangeMouseDown={this.rangeMouseDown}
          rangeMouseMove={this.rangeMouseMove}
          calcularPosition={this.calcularPosition}
          mode={mode}
        />
      );
    }
    return (
      <ViewTemperature
        color={color}
        backgroundColor={backgroundColor}
        inverted={inverted}
        disabled={disabled}
        unit={unit}
        start={settings.start}
        offset={offset}
        setValueByInput={this.setValueByInput}
        rangeMouseDown={this.rangeMouseDown}
        rangeMouseMove={this.rangeMouseMove}
        calcularPosition={this.calcularPosition}
        mode={mode}
      />
    );
  }
}

Slider.propTypes = {
  basic: PropTypes.bool,
  settings: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    start: PropTypes.number,
    onChange: PropTypes.func,
  }),
  inverted: PropTypes.bool,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  unit: PropTypes.string,
  disabled: PropTypes.bool,
  mode: PropTypes.string,
};

Slider.defaultProps = {
  basic: false,
  color: 'none',
  backgroundColor: 'none',
  inverted: false,
  settings: {
    min: 0,
    max: 10,
    step: 1,
    start: 0,
  },
  disabled: false,
  unit: '',
  mode: null,
};
